import { Group } from 'src/design/atoms/Group';
import { Paper } from 'src/design/atoms/Paper';
import { SimpleGrid } from 'src/design/atoms/SimpleGrid';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import { IconBriefcase2 } from '@tabler/icons-react';
import React from 'react';
import { JobDto } from 'src/api/FiretrolApiClient';
import { useAuth } from 'src/hooks/useAuth';
import { AnchorLink } from 'src/design/molecules/AnchorLink';
import { getCurrentWorkWeek } from 'src/utils/workWeek';

interface MyWorkTabProps {
  jobs: JobDto[];
  loading: boolean;
}

export const MyWorkTab: React.FC<MyWorkTabProps> = ({ jobs, loading }) => {
  const { user } = useAuth();
  const { weekNumber: currentWeek, year: currentYear } = getCurrentWorkWeek();

  if (!loading && jobs.length === 0) {
    return (
      <Stack align="center" justify="center" py="xl">
        <IconBriefcase2 size={36} color="gray" />
        <Text c="dimmed" size="md">
          You don't have any active service jobs.
        </Text>
        <Text c="dimmed" size="xs">
          Service jobs are created by administrators for service technicians.
        </Text>
      </Stack>
    );
  }

  return (
    <Stack mt="md">
      <Text c="dimmed">
        Click on a service job below to access your current timesheet.
      </Text>
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="md">
        {jobs.map((job) => (
          <Paper key={job.id}>
            <Stack gap="xs">
              <Group justify="space-between">
                <Title order={5}>{job.name}</Title>
              </Group>
              <Text size="sm" c="dimmed">
                Office: {job.serviceOffice?.name || '--'}
              </Text>
              <AnchorLink
                to={`/jobs/${job.id}/timesheets/user/${user?.id}/week/${currentYear}/${currentWeek}`}
              >
                Open Current Timesheet
              </AnchorLink>
            </Stack>
          </Paper>
        ))}
      </SimpleGrid>
    </Stack>
  );
};
